import { Factory } from 'fishery'
import { type OpalApiComponent } from '@opallabs/api'
import {
  EMPTY_TO_MANY,
  EMPTY_TO_ONE,
  linkageFromResource,
} from '@opallabs/json-api'
import { longString, string } from '@opallabs/testing/src/strings'
import { userResourceFactory } from './user'

type UserGroupResourceV3 = OpalApiComponent<'V3', 'user_group'>

export const userGroupResourceFactory: Factory<UserGroupResourceV3> =
  Factory.define<UserGroupResourceV3>(({ sequence }) => {
    const creator = userResourceFactory.build()

    return {
      id: crypto.randomUUID(),
      type: 'user_group',
      attributes: {
        created_at: new Date().toISOString(),
        description: longString(),
        is_archived: false,
        external_resource_type: null,
        name: `${string()} ${sequence}`,
        updated_at: new Date().toISOString(),
      },
      relationships: {
        asset: EMPTY_TO_ONE,
        created_by_user: linkageFromResource(creator),
        external_resource: EMPTY_TO_ONE,
        inherited_groups: EMPTY_TO_MANY,
        members: linkageFromResource([
          userResourceFactory.build(),
          userResourceFactory.build(),
          userResourceFactory.build(),
        ]),
      },
    } satisfies UserGroupResourceV3
  })
